// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Yaqyn","cell":"ColumnAccessor_cell__3vtQm","firstCellAccent":"ColumnAccessor_firstCellAccent__3MCLP"};